export const setSessionStorageItem = (key, value) => sessionStorage.setItem(key, value);

export const getItemFromSessionStorage = key => sessionStorage.getItem(key);

export const removeFromSessionStorage = key => sessionStorage.removeItem(key);

export const clearSessionStorage = key => sessionStorage.clear();
